export interface MinuteApprovalRuleMinDTO {
    minuteRequestApprovalRuleId: number;
    name: string;
    minApprovalRequired: number;
    priority: number;
    enabled: boolean;
    numConditions: number;
}

export enum MinuteApprovalConditionEnum {
    greatThanOrEqual = 0,
    lessThanOrEqual = 1,
    equals = 2,
    has = 3
}

export const MinuteApprovalConditionComparator = new Map<number, string>([
    [MinuteApprovalConditionEnum.greatThanOrEqual, '>='],
    [MinuteApprovalConditionEnum.lessThanOrEqual, '<='],
    [MinuteApprovalConditionEnum.equals, '='],
    [MinuteApprovalConditionEnum.has, 'Tiene']
])

/**
 * Interfaz que representa todo el detalle de una regla de aprobacion de minuta
 */
export interface MinuteRequestApprovalRuleDetailDTO {
    minuteRequestApprovalRuleId: number;
    name: string;
    description: string;
    minApprovalRequired: number;
    priority: number;
    enabled: boolean;
    conditions: MinuteRequestApprovalConditionDTO[];
    roles: MinuteRequestApprovalAllowedRoleDTO[];
}

export interface MinuteRequestApprovalConditionDTO {
    minuteRequestApprovalRuleConditionId: number;
    value: bigint;
    comparator: MinuteApprovalConditionEnum;
    minuteApprovalParameterId: number;
    minuteApprovalParameterName: string;
    contextualValue: string;
}

export interface MinuteRequestApprovalAllowedRoleDTO {
    roleId: number;
    name: string;
} 